// import 'reflect-metadata';
import 'zone.js'; // Included with Angular CLI.

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// if ((module as any).hot) {
//   (module as any).hot.accept();
//   console.warn('⚠️ HMR triggered — auth flow may be affected');
// }


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error('LMS Error:', err));
